import React, { useState, useEffect } from "react";
import { makeStyles, Drawer } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Avatar, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Divider, Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import HeaderLogin from "../../components/HeaderLogin";
import clsx from "clsx";
import { SERVER_URL } from "../../config/backend";
import fns_format from "date-fns/format";
import { parseISO } from "date-fns";
import ModalMensajes from "../../components/ModalMensajes";
import Loader from "../../components/Loader";
import { Notificaciones } from "../../request/request_home";

const useStyles = makeStyles((theme) => ({
    gridItem: {
        padding: "0px",
        margin: "0px",
    },
    paperContainer: {
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
    },
    imageSize2160: {
        backgroundImage: `url(${require("../../static/Imágenes/InicioSesion/webp/Background.webp")})`,
    },
    drawerPaper: {
        background: "#A68A30",
        width: window.screen.width > 600 ? 600 : window.screen.width,
    },
    drawer: {
        flexShrink: 0,
    },
    modalContent: {
        backgroundColor: theme.palette.primary.main,
    },
    modalActions: {
        backgroundColor: theme.palette.primary.main,
        textAlign: "center",
    },
    buttonModal: {
        width: 150,
        color: "#FFFFFF",
        fontSize: "12px",
        fontFamily: "Verdana Bold",
        borderRadius: 8,
        opacity: "200%",
        background: "linear-gradient(900deg, #F7D00E 30%, #A68A30 90%)",
        paddingTop: 8,
        paddingBottom: 8,
        "&:hover": {
            background: "#DFDFDF",
        },
    },
    textoHeader: {
        color: theme.palette.secondary.dark,
        fontWeight: "bold",
        fontSize: "14pt",
        textAlign: "center",
    },
    texto: {
        color: theme.palette.common.white,
    },
    divider: {
        height: "8px",
        backgroundColor: theme.palette.secondary.dark,
        width: "15%",
    },
}));

export default function Vista_Notificaciones(props) {
    const { globalNotificaciones, setGlobalNotificaciones } = props;
    const dispatch = useDispatch();
    const selector = useSelector((store) => store);
    const classes = useStyles();

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const globalLang = useSelector((store) => (store.user.lang === undefined ? "es" : store.user.lang));
    const [openLoader, setOpenLoader] = useState(false);
    const [ancho, setAncho] = useState(window.screen.width);
    const [openModal, setOpenModal] = useState(false);
    const [idEliminar, setIdEliminar] = useState(false);
    const [openModalMensajes, setOpenModalMensajes] = useState(false);
    const [cuerpoModalMensajes, setCuerpoModalMensajes] = useState({
        tituloModal: "informacion",
        textoModal: "",
    });

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------
    const handleClickClose = () => {
        dispatch({ type: "DRAWER_OPERATION_NOTIFICACION", status: false });
    };

    const handleOpcionEliminarNotificacion = (id_notf) => {
        setOpenModal(true);
        setIdEliminar(id_notf);
    };

    const eliminarNotificacion = async () => {
        var eliminarNotificacion = `mutation eliminarNotificacion($input: ID!) {
            deleteNotification(id: $input) {
                status
                errors {
                    messages
                    field
                }
            }
        }`;

        await fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + selector.user.accessToken,
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            },
            body: JSON.stringify({
                operationName: "eliminarNotificacion",
                query: eliminarNotificacion,
                variables: {
                    input: idEliminar,
                },
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data["data"]["deleteNotification"]) {
                    if (data["data"]["deleteNotification"]["status"] === 200) {
                        setOpenLoader(true);
                        Notificaciones(globalLang, selector.user.accessToken)
                            .then((item) => {
                                setGlobalNotificaciones(item);
                            })
                            .finally(() => {
                                setOpenLoader(false);
                            });
                    } else {
                        setCuerpoModalMensajes({
                            ...cuerpoModalMensajes,
                            tituloModal: "informacion",
                            textoModal: <FormattedMessage id="informacion_error_eliminar_notificacion" />,
                        });
                        setOpenModalMensajes(true);
                    }
                } else {
                    setCuerpoModalMensajes({
                        ...cuerpoModalMensajes,
                        tituloModal: "informacion",
                        textoModal: <FormattedMessage id="informacion_error_eliminar_notificacion" />,
                    });
                    setOpenModalMensajes(true);
                }
                setOpenModal(false);
            });
    };

    //-------------------------------------------------------------------------------
    //--------------------------------VISTA------------------------------------------
    //-------------------------------------------------------------------------------

    useEffect(() => {
        window.addEventListener("resize", function () {
            setAncho(window.screen.width);
        });
    }, []);

    return (
        <div>
            {openLoader ? <Loader /> : ""}
            <Drawer
                className={classes.drawer}
                variant="temporary"
                anchor="right"
                open={selector.user.open_drawer_notification}
                classes={{
                    paper: classes.drawerPaper,
                }}
                onEscapeKeyDown={handleClickClose}
                onBackdropClick={handleClickClose}
            >
                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.gridItem}>
                        <div className={clsx(classes.imageSize2160, classes.paperContainer)}>
                            <HeaderLogin namePage={<FormattedMessage id="notificaciones_m" />} />
                        </div>
                    </Grid>
                    {globalNotificaciones.map((item) => (
                        <Grid key={item.id} item container justify="center" alignItems="center" xs={12}>
                            <Grid item container xs={1} />
                            <Grid item container xs={10} style={{ backgroundColor: "#182C20", borderRadius: 8, padding: ancho < 576 ? 10 : 15, margin: "10px 0" }}>
                                <Grid item container alignItems="flex-start" justify="center" xs={2}>
                                    <Avatar alt="usuario" src={item.photo.url} style={{ width: ancho < 576 ? 45 : 80, height: ancho < 576 ? 45 : 80 }} />
                                </Grid>
                                <Grid item container alignItems="center" xs={9} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                    <Grid item container alignItems="center" xs={12}>
                                        <div
                                            style={{
                                                color: "#F2F2F2",
                                                fontSize: 14,
                                            }}
                                        >
                                            <b>
                                                <FormattedMessage id="fecha" />:{" "}
                                            </b>
                                            {fns_format(parseISO(item.datetime), "dd/MM/yyyy hh:mm aaa")}
                                        </div>
                                    </Grid>
                                    <Grid item container alignItems="center" xs={12}>
                                        <div
                                            style={{
                                                color: "#F2F2F2",
                                                fontSize: 14,
                                            }}
                                        >
                                            <b>
                                                <FormattedMessage id="asunto" />:{" "}
                                            </b>
                                            {item.subject}
                                        </div>
                                    </Grid>
                                    <Grid item container alignItems="center" xs={12}>
                                        <div
                                            style={{
                                                color: "#F2F2F2",
                                                fontSize: 14,
                                            }}
                                        >
                                            <b>
                                                <FormattedMessage id="descripcion" />:{" "}
                                            </b>
                                            {item.content}
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid item container xs={1}>
                                    <IconButton
                                        onClick={() => {
                                            handleOpcionEliminarNotificacion(item.id);
                                        }}
                                    >
                                        <img alt="trash" src={require("../../static/Íconos/Latón blanco.svg")} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid item container xs={1} />
                        </Grid>
                    ))}
                </Grid>
            </Drawer>

            <Dialog
                maxWidth="sm"
                open={openModal}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenModal(false);
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="max-width-dialog-title"
                fullWidth
            >
                <DialogTitle id="max-width-dialog-title" className={classes.modalContent}>
                    <Grid item container xs={12}>
                        <Grid item xs={12} container justify="center" alignItems="center">
                            <img
                                alt=""
                                src={require("../../static/Identificador/Logo hotel dorado.svg")}
                                style={{
                                    height: "100px",
                                    width: "100px",
                                    marginBottom: 10,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} container justify="center" alignItems="center">
                            <Typography className={classes.textoHeader}>
                                <FormattedMessage id="eliminar_notificacion" />
                            </Typography>
                        </Grid>
                        <Grid item xs={12} container justify="center" alignItems="center">
                            <Divider className={classes.divider} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className={classes.modalContent}>
                    <Grid item container xs={12} justify="center" alignItems="center">
                        <Typography className={classes.texto}>
                            <FormattedMessage id="informacion_eliminar_notificacion" />
                        </Typography>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalActions}>
                    <Grid item container xs={12} justify="center" alignItems="center" style={{ marginBottom: 20 }}>
                        <Button variant="contained" onClick={eliminarNotificacion} className={classes.buttonModal} style={{ marginRight: ancho < 576 ? 0 : 10 }}>
                            <FormattedMessage id="aceptar" />
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setOpenModal(false);
                            }}
                            className={classes.buttonModal}
                            style={{ marginTop: ancho < 576 ? 10 : 0 }}
                        >
                            <FormattedMessage id="cancelar" />
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>

            {/* Dialogo Mensaje */}
            <ModalMensajes openModal={openModalMensajes} setOpenModal={setOpenModalMensajes} cuerpoModal={cuerpoModalMensajes} />
        </div>
    );
}
